import React, { useState, useEffect } from "react";
import Footer from "components/Footers/Footer";
import IndexNavbar from "components/Navbars/IndexNavbar";
import snackfood from "assets/img/snackfood.jfif";
import nuts from "assets/img/nuts.jfif";
import spices from "assets/img/spices.jfif";
import vegetables from "assets/img/vegetables.jfif";
import bakery from "assets/img/bakery.jfif";
import frozen from "assets/img/frozen.jfif";
import nonfood from "assets/img/nonfood.jfif";
import newbg from "assets/img/newbg.jpg";
const Industries = () => {
  return (
    <section className="parkinsans">
      <IndexNavbar />
      <section className="xl:pt-0 lg:pt-0 md:pt-24 pt-20">
        <div
          className="relative xl:h-450 lg:h-300 md:h-380 h-350-px"
          style={{
            backgroundImage: `url(${newbg})`,
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
          }}
        >
          {/* Black Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>

          <div style={{ position: "relative", zIndex: 10 }}>
            <div className="xl:gap-0">
              <div className="xl:pt-36 lg:pt-24 md:pt-36 pt-32">
                <h1 className="xl:text-7xl lg:text-5xl md:text-4xl text-4xl text-center text-white uppercase font-bold fade-item-1">
                  Industries We Serve
                </h1>

                <div>
                  <div className="flex items-center justify-center bg-[#FDF5E6] rounded-lg xl:mt-6 lg:mt-4 mt-4">
                    <div
                      className="xl:w-3/12 lg:w-2/12 md:w-2/12 py-2 px-2 flex items-center gap-2 justify-center fade-item-2"
                      style={{ border: "1px dashed white" }}
                    >
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        Home
                      </span>
                      <span className="text-white font-semibold"> »</span>
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        Industries We Serve
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="headerbg1 xl:pt-24 xl:pb-24">
        <div className="container mx-auto xl:px-12 grid grid-cols-2 xl:gap-4">
          <div>
            <div>
              <img className="xl:w-10/12" src={snackfood} alr="" />
            </div>
          </div>

          <div className="flex items-center">
            <div>
              <h1 className="xl:text-5xl font-bold text-black textt ">
                Snack Food
              </h1>
              <p className="xl:text-lg text-para xl:pt-6">
                The Indian Snack Market includes Western Snacks like Potato
                Chips, Extruded Snacks and pellets but also a variety of
                products that are regionally specific and are commonly known as
                Namkeen. In the north, products like Bhujiya & Aloo Bhujiya,
                mixtures like Navratan & Khatta Meetha, and in the south, banana
                & tapioca chips. FPT is trusted by leaders of the industry for
                its snack food processing systems.
              </p>
              <button className="bg-green rounded-md xl:px-8 xl:py-4 lg:px-4 lg:py-4 xl:mt-6 lg:mt-4  text-white   md:px-4 py-2 mt-2">
                Learn More
              </button>
            </div>
          </div>
        </div>

        {/* item 2 */}
        <div className="container mx-auto xl:px-12 grid grid-cols-2 xl:gap-4 xl:mt-16">
          <div className="flex items-center">
            <div>
              <h1 className="xl:text-5xl font-bold text-black textt ">
                Dried Fruits & Nuts
              </h1>
              <p className="xl:text-lg text-para xl:pt-6">
                From sorting, mixing and roasting, let us simplify your
                manufacturing process with our world-class principals for the
                dry fruit & nut industry.
              </p>
              <button className="bg-green rounded-md xl:px-8 xl:py-4 lg:px-4 lg:py-4 xl:mt-6 lg:mt-4  text-white   md:px-4 py-2 mt-2">
                Learn More
              </button>
            </div>
          </div>

          <div>
            <div>
              <img className="xl:w-10/12" src={nuts} alr="" />
            </div>
          </div>
        </div>

        {/* item 3 */}
        <div className="container mx-auto xl:px-12 grid grid-cols-2 xl:gap-4 xl:mt-16">
          <div>
            <div>
              <img className="xl:w-10/12" src={spices} alr="" />
            </div>
          </div>
          <div className="flex items-center">
            <div>
              <h1 className="xl:text-5xl font-bold text-black textt ">
                Spices & Powders
              </h1>
              <p className="xl:text-lg text-para xl:pt-6">
                With traditional spices sought after all over the world, FPT
                will simplify your production process so you can meet the global
                demand. Our principals are also equipped to cater to your needs
                in any kind of powders, such as castor sugar, fruit drink
                powders, chocolate/malt powders, etc.
              </p>
              <button className="bg-green rounded-md xl:px-8 xl:py-4 lg:px-4 lg:py-4 xl:mt-6 lg:mt-4  text-white   md:px-4 py-2 mt-2">
                Learn More
              </button>
            </div>
          </div>
        </div>

        {/* item 4 */}
        <div className="container mx-auto xl:px-12 grid grid-cols-2 xl:gap-4 xl:mt-16">
          <div className="flex items-center">
            <div>
              <h1 className="xl:text-5xl font-bold text-black textt ">
                Fruits & Vegetables
              </h1>
              <p className="xl:text-lg text-para xl:pt-6">
                With traditional spices sought after all over the world, FPT
                will simplify your production process so you can meet the global
                demand. Our principals are also equipped to cater to your needs
                in any kind of powders, such as castor sugar, fruit drink
                powders, chocolate/malt powders, etc.
              </p>
              <button className="bg-green rounded-md xl:px-8 xl:py-4 lg:px-4 lg:py-4 xl:mt-6 lg:mt-4  text-white   md:px-4 py-2 mt-2">
                Learn More
              </button>
            </div>
          </div>

          <div>
            <div>
              <img className="xl:w-10/12" src={vegetables} alr="" />
            </div>
          </div>
        </div>

        {/* item 5 */}
        <div className="container mx-auto xl:px-12 grid grid-cols-2 xl:gap-4 xl:mt-16">
          <div>
            <div>
              <img className="xl:w-10/12" src={bakery} alr="" />
            </div>
          </div>
          <div className="flex items-center">
            <div>
              <h1 className="xl:text-5xl font-bold text-black textt ">
                Bakery
              </h1>
              <p className="xl:text-lg text-para xl:pt-6">
                Baked goods are increasing in popularity. With the increasing
                size of the fast-food industry, bread is in demand for burgers,
                sandwiches, etc. FPT offers end-to-end turnkey solutions for
                your bakery, so you can meet the rising demand easily.
              </p>
              <button className="bg-green rounded-md xl:px-8 xl:py-4 lg:px-4 lg:py-4 xl:mt-6 lg:mt-4  text-white   md:px-4 py-2 mt-2">
                Learn More
              </button>
            </div>
          </div>
        </div>

        {/* item 6 */}
        <div className="container mx-auto xl:px-12 grid grid-cols-2 xl:gap-4 xl:mt-16">
          <div className="flex items-center">
            <div>
              <h1 className="xl:text-5xl font-bold text-black textt ">
                Frozen Foods
              </h1>
              <p className="xl:text-lg text-para xl:pt-6">
                We offer solutions, including quick-freezing and packaging for
                vegetables, french fries, and speciality products. From the
                production line to the supermarket, our complete process
                solutions will aid you.
              </p>
              <button className="bg-green rounded-md xl:px-8 xl:py-4 lg:px-4 lg:py-4 xl:mt-6 lg:mt-4  text-white   md:px-4 py-2 mt-2">
                Learn More
              </button>
            </div>
          </div>

          <div>
            <div>
              <img className="xl:w-10/12" src={frozen} alr="" />
            </div>
          </div>
        </div>

        <div className="container mx-auto xl:px-12 grid grid-cols-2 xl:gap-4 xl:mt-16">
          <div>
            <div>
              <img className="xl:w-10/12" src={nonfood} alr="" />
            </div>
          </div>

          <div className="flex items-center">
            <div>
              <h1 className="xl:text-5xl font-bold text-black textt ">
                Non-Food
              </h1>
              <p className="xl:text-lg text-para xl:pt-6">
                State-of-the-art systems for pharmaceutical powders, detergents,
                household chemicals, etc. With mixers, homogenizers, and
                inspection systems, our solutions add value to a variety of
                non-food production lines.
              </p>
              <button className="bg-green rounded-md xl:px-8 xl:py-4 lg:px-4 lg:py-4 xl:mt-6 lg:mt-4  text-white   md:px-4 py-2 mt-2">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
};
export default Industries;
